import * as S from "./styled";

export const Footer = ({ percent = 0 }) => {
  return (
    <S.FooterContainer>
      <S.FooterTitle>TOTALS</S.FooterTitle>
      <S.PercentTotal>{percent}%</S.PercentTotal>
    </S.FooterContainer>
  );
};
